export default function RowReadOnly({ name, value }: { name: string; value: string }) {
  return (
    <div className="flex items-center justify-between px-4 py-3">
      <span className="text-left font-medium text-gray-900 text-sm">{name}</span>
      <span className="text-right text-gray-700 text-sm">{value}</span>
    </div>
  );
}
